import './App.css'
import { Route, Routes } from 'react-router-dom'
import SignIn from './pages/signin'
import { RequireAuth } from './components/RequireAuth'
import Overview from './pages/overview'
import Layout from './components/layout'
import Customers from './pages/customers'
import Talents from './pages/talents'
import System from './pages/system'
import Challenges from './pages/challenges'
import Customer from './pages/customer'
import Payment from './pages/payment'
import Leads from './pages/leads'
import FunnelDropouts from './pages/funnel-dropouts'
import Integrations from './pages/integrations'
import Dimensions from './pages/dimensions'
import CopyPosition from './pages/copy-position'
import MoveSpaces from './pages/move-spaces'
import ReportLink from './pages/report-link'
import Analytics from './pages/analytics'
import Assistant from './pages/assistant'
import Tomato from './pages/tomato'
import Experiments from './pages/experiments'
import Experiment from './pages/experiment'
import PricingMigration from './pages/pricing-migration'

function App() {
  return (
    <Routes>
      <Route path='/login' element={<SignIn />} />
      <Route path='/tomato' element={<Tomato />} />
      <Route
        path='/'
        element={
          <RequireAuth>
            <Layout />
          </RequireAuth>
        }
      >
        <Route index element={<Overview />} />
        <Route path='customers' element={<Customers />} />
        <Route path='leads' element={<Leads />} />
        <Route path='funnel-dropouts' element={<FunnelDropouts />} />
        <Route path='customer/:id' element={<Customer />} />
        <Route path='customer/payment/:id' element={<Payment />} />
        {/* Entwurf einer neuen Zahlung, ?from=<paymentId> belegt ihn vor.
            Der key sorgt dafür, dass nach dem Anlegen die Bearbeitung mit
            frischem State startet statt den Entwurf weiterzuführen. */}
        <Route
          path='customer/:partnerId/payment/new'
          element={<Payment key='new' />}
        />
        <Route path='pricing-migration' element={<PricingMigration />} />
        <Route path='talents' element={<Talents />} />
        <Route path='system' element={<System />} />
        <Route path='system/challenges' element={<Challenges />} />
        <Route path='system/dimensions' element={<Dimensions />} />
        <Route path='system/transfer-position' element={<CopyPosition />} />
        <Route path='system/move-spaces' element={<MoveSpaces />} />
        <Route path='system/report-link' element={<ReportLink />} />
        <Route path='integrations' element={<Integrations />} />
        <Route path='analytics' element={<Analytics />} />
        <Route path='assistant' element={<Assistant />} />
        <Route path='experiments' element={<Experiments />} />
        <Route path='experiments/:key' element={<Experiment />} />
      </Route>
      <Route path='*' element={<p>Page not found</p>} />
    </Routes>
  )
}

export default App
